import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import profileService from './profileService'

const initialState = {
  profile: null,
  profileLoading: null,
  profileError: null,
}

// @desc Get Users
export const getMyAccount = createAsyncThunk(
  'myPage/get',
  async (token, thunkAPI) => {
    try {
      return await profileService.getMyAccount(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// @desc UPDATE My Account
export const updateMyAccount = createAsyncThunk(
  'myPage_account/update',
  async ({ data, token }, thunkAPI) => {
    try {
      return await profileService.updateMyAccount(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// @desc UPDATE My Password
export const updateMyPassword = createAsyncThunk(
  'myPage_password/update',
  async ({ data, token }, thunkAPI) => {
    try {
      return await profileService.updateMyPassword(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    resetProfile: (state) => {
      state.profile = null
      state.profileError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // GET User
      .addCase(getMyAccount.pending, (state) => {
        state.profileLoading = true
      })
      .addCase(getMyAccount.fulfilled, (state, action) => {
        state.profile = action.payload.res.data
        state.profileLoading = false
      })
      .addCase(getMyAccount.rejected, (state, action) => {
        state.profileError = action.payload
        state.profileLoading = false
      })
      // UPDATE User
      .addCase(updateMyAccount.pending, (state) => {
        state.userLoading = true
      })
      .addCase(updateMyAccount.fulfilled, (state) => {
        state.userLoading = false
      })
      .addCase(updateMyAccount.rejected, (state, action) => {
        state.profileError = action.payload
        state.userLoading = false
      })
      // UPDATE Password
      .addCase(updateMyPassword.pending, (state) => {
        state.userLoading = true
      })
      .addCase(updateMyPassword.fulfilled, (state) => {
        state.userLoading = false
      })
      .addCase(updateMyPassword.rejected, (state, action) => {
        state.profileError = action.payload
        state.userLoading = false
      })
  },
})

export const { resetProfile } = profileSlice.actions

export default profileSlice.reducer
